import isAccountApplicableProduct from '../resolvers/isAccountApplicableProduct';
import applyAccountToSinglePeriod from './applyAccountToSinglePeriod';

/**
 * Under certain conditions account update could precede the periods update.
 * In such case queue pending merge-update and execute it once periods update triggers
 * application of the merge.
 *
 * @type {object}
 */
let queue = {};

/**
 * This function is responsible for mutating periods map on product's account change.
 * To reduce complexity of reducer and decouple specialized logic into separate function
 * any on-account-change specific mutations that impacts periods should be placed within
 * the current function (when it's applicable).
 *
 * @param {object} periods
 * @param {{type, data: {productId, account, [merge]}}} action
 * @param {boolean} [cleanQueueFlag]
 */
export default (periods, action, cleanQueueFlag) => {
    cleanQueueFlag = typeof cleanQueueFlag === 'undefined' ? true : !!cleanQueueFlag;
    const productId = +action?.data?.productId;
    const accountId = +action?.data?.account;
    const queueId = `${productId}_${accountId}`;

    // Custom period listing applies only to doBoard service at the moment.
    if (!!accountId && isAccountApplicableProduct({ product_id: productId })) {
        let merge = action.data?.merge || queue[queueId] || {};

        // If periods for cart are already available.
        if (!!periods) {
            for (const index in periods) {
                applyAccountToSinglePeriod(periods[index], merge?.account_periods);
            }
            if (cleanQueueFlag) {
                // Clean-up after merge.
                delete queue[queueId];
            }
        } else {
            // In case of periods are still not loaded / updated, queuing update to it for the current
            // productId and accountId.
            queue[queueId] = merge;
        }
    }
}
